// extracted by mini-css-extract-plugin
export var academyLogoutButton = "universalNavigation-module--academyLogoutButton--08c04";
export var active = "universalNavigation-module--active--babd1";
export var container = "universalNavigation-module--container--39f3e";
export var cta = "universalNavigation-module--cta--8b7a5";
export var ctaList = "universalNavigation-module--ctaList--6ddca";
export var ctaListItem = "universalNavigation-module--ctaListItem--5c2f9";
export var dark = "universalNavigation-module--dark--60cd5";
export var drawer = "universalNavigation-module--drawer--4e69f";
export var flag = "universalNavigation-module--flag--a7155";
export var hasChildren = "universalNavigation-module--hasChildren--8ef12";
export var invertOnHover = "universalNavigation-module--invertOnHover--dc12b";
export var link = "universalNavigation-module--link--5ad12";
export var list = "universalNavigation-module--list--1c3da";
export var listItem = "universalNavigation-module--listItem--f5218";
export var logo = "universalNavigation-module--logo--0f451";
export var logoContainer = "universalNavigation-module--logoContainer--87d62";
export var mobileMenuToggle = "universalNavigation-module--mobileMenuToggle--8c94a";
export var nav = "universalNavigation-module--nav--bca88";
export var openOnClick = "universalNavigation-module--openOnClick--e584c";
export var primary = "universalNavigation-module--primary--228b7";
export var scrolled = "universalNavigation-module--scrolled--720c3";
export var secondary = "universalNavigation-module--secondary--5f87a";
export var showSubnav = "universalNavigation-module--showSubnav--6a611";
export var tertiary = "universalNavigation-module--tertiary--820ae";
export var toggleButton = "universalNavigation-module--toggleButton--eb0f2";
export var universalNavigation = "universalNavigation-module--universalNavigation--4342d";